import { VFC } from 'react';
import styled from '@emotion/styled/macro';
import { VoteResultSelectValues } from './types';
import { Label } from './Label';

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background-color: white;
`;

const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
`;

const StyledOption = styled.div<{ position?: 'left' | 'right' }>`
  display: flex;
  height: 55px;
  min-width: 82px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
`;

const StyledLabel = styled.label`
  position: relative;

  ${StyledInput}:checked + ${StyledOption} {
    background-color: red;
    color: white;
  }
`;

const RADIO_NAME = 'vote-result';

interface IVoteResultSwitchProps {
  selectedOption: VoteResultSelectValues;
  onRadioButtonChange: (selectedMethod: VoteResultSelectValues) => void;
}

export const VoteResultSwitch: VFC<IVoteResultSwitchProps> = ({
  selectedOption,
  onRadioButtonChange,
}) => (
  <div>
    <Label>Výsledek hlasování</Label>
    <StyledWrapper>
      <StyledLabel>
        <StyledInput
          id={`${RADIO_NAME}-${VoteResultSelectValues.Accepted}`}
          type={'radio'}
          name={RADIO_NAME}
          checked={selectedOption === VoteResultSelectValues.Accepted}
          onChange={() => onRadioButtonChange(VoteResultSelectValues.Accepted)}
        />
        <StyledOption position={'left'}>Přijato</StyledOption>
      </StyledLabel>
      <StyledLabel>
        <StyledInput
          id={`${RADIO_NAME}-${VoteResultSelectValues.All}`}
          type={'radio'}
          name={RADIO_NAME}
          checked={selectedOption === VoteResultSelectValues.All}
          onChange={() => onRadioButtonChange(VoteResultSelectValues.All)}
        />
        <StyledOption>Vše</StyledOption>
      </StyledLabel>
      <StyledLabel>
        <StyledInput
          id={`${RADIO_NAME}-${VoteResultSelectValues.Rejected}`}
          type={'radio'}
          name={RADIO_NAME}
          checked={selectedOption === VoteResultSelectValues.Rejected}
          onChange={() => onRadioButtonChange(VoteResultSelectValues.Rejected)}
        />
        <StyledOption position={'right'}>Nepřijato</StyledOption>
      </StyledLabel>
    </StyledWrapper>
  </div>
);
